import { memo } from 'react'

import { SelectWrapperProps } from '@/components'
import { EnhancedAsyncSelect } from '@/lib/components/Select/EnhancedAsyncSelect/EnhancedAsyncSelect'
import { SelectWithoutForm } from '@/lib/components/Select/EnhancedSyncSelect/EnhancedSyncSelect'

export const Select = memo(
	({
		isAsync,
		commonProps,
		onChange,
		optionValue,
		optionLabel,
		isNumeric,
		columnHeader,
		getOptionLabel,
		formatOptionLabel,
		loadOptions,
		testId,
		isTableCell,
	}: SelectWrapperProps) => {
		if (isAsync) {
			const asyncSelect = (
				<EnhancedAsyncSelect
					{...commonProps}
					onChange={onChange}
					valueKey={optionValue}
					labelKey={optionLabel}
					isNumeric={isNumeric}
					loadOptions={loadOptions}
					formatOptionLabel={formatOptionLabel}
					menuPortalTarget={document.body}
					menuPosition="fixed"
					useBaseStyles
					testId={testId}
					isTableCell={isTableCell}
				/>
			)

			return isTableCell ? asyncSelect : <div className="py-2">{asyncSelect}</div>
		}

		return (
			<SelectWithoutForm
				{...commonProps}
				name={columnHeader}
				onChange={onChange}
				valueKey={optionValue}
				labelKey={optionLabel}
				isNumeric={isNumeric}
				formatOptionLabel={getOptionLabel}
				customStyles={{ backgroundColor: 'none' }}
				testId={testId}
				isTableCell={isTableCell}
			/>
		)
	},
)
